<template>
  <m-dialog ref="dlg" @save="save" :title="atribut && atribut.atribut_id ? 'Ubah Atribut' : 'Tambah Atribut'">
    <v-container>
      <v-form @submit.prevent data-vv-scope="form" lazy-validation>
        <v-row row wrap justify="center" align="center">
          <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="py-0">
            <label class="caption mb-2">Label Atribut</label>
            <v-text-field
              autofocus
              dense
              single-line
              outlined
              label="Label Atribut"
              v-model="atribut.nama"
              persistent-hint
              hint="Label Atribut Yang Digunakan Akan Muncul Saat Tambah Anggota Baru. Contoh: Pendidikan Terakhir"
              data-vv-name="atribut"
              data-vv-as="Label Atribut"
              v-validate="'required'"
              :error-messages="errors.collect('form.atribut')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="py-0">
            <label class="caption mb-2">Tipe</label>
            <v-select
              dense
              single-line
              outlined
              :items="types"
              v-model="atribut.tipe"
              label="Tipe"
              data-vv-name="tipe"
              data-vv-as="Tipe"
              v-validate="'required'"
              :error-messages="errors.collect('form.tipe')"
              @change="reset"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="py-0">
            <label class="caption mb-2">Cetak Laporan</label>
            <v-checkbox v-model="atribut.is_laporan" label="Cetak Atribut ke laporan ?" :value="Number(1)" />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="8"
            lg="8"
            xl="8"
            v-if="atribut.tipe == 'Teks' || atribut.tipe == 'Angka'"
            class="py-0"
          >
            <label class="caption mb-2">Isian Umum</label>
            <v-text-field
              dense
              single-line
              outlined
              label="Isian Umum"
              v-model="atribut.default_value"
              hint="Isian Umum dari Atribut yang dibuat"
              data-vv-name="default_value"
              data-vv-as="Isian Umum"
              v-validate="'required'"
              :error-messages="errors.collect('form.default_value')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="8" lg="8" xl="8">
            <div v-if="atribut.tipe == 'Pilihan'">
              <v-alert text dense color="blue" icon="mdi-information-outline" border="left"
                >Masukkan Pilihan {{ atribut.nama }}</v-alert
              >
              <div v-for="(item, index) in jumlahAtribut" :key="item">
                <v-row wrap>
                  <v-col cols="10" class="py-0">
                    <label class="caption mb-2">Pilihan</label>
                    <v-text-field
                      dense
                      single-line
                      outlined
                      label="Pilihan"
                      hint="Masukkan Pilihan"
                      v-model="arrayAtribut[index]"
                      data-vv-name="default_value"
                      data-vv-as="default_value"
                      v-validate="'required'"
                      @keyup.enter="add"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-btn depressed fab color="red" small @click="remove(index)">
                      <v-icon color="white">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <v-btn class="mt-2" depressed fab small color="blue" @click="add">
                <span class="white--text">
                  <v-icon>mdi-plus</v-icon>
                </span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      roles: [],
      atribut: {},
      types: ['Teks', 'Angka', 'Pilihan'],
      jumlahAtribut: 1,
      arrayAtribut: [],
      defAtribut: {
        nama: null,
      },
    }
  },
  mounted() {},
  methods: {
    // eslint-disable-next-line
    open(obj) {
      if (obj) {
        this.jumlahAtribut = obj.default_value.length
        this.arrayAtribut = obj.default_value
      } else {
        this.jumlahAtribut = 1
        this.arrayAtribut = []
      }
      this.$validator.reset()
      this.atribut = obj ? { ...obj } : { ...this.defAtribut }
      return this.$refs.dlg.open()
    },
    add() {
      this.jumlahAtribut += 1
    },
    remove(index) {
      this.jumlahAtribut -= 1
      this.arrayAtribut.splice(index, 1)
    },
    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          this.atribut.tipe == 'Pilihan'
            ? (this.atribut.default_value = this.arrayAtribut)
            : (this.atribut.default_value = this.atribut.default_value)

          this.$set(this.atribut, 'kode_organisasi', this.organisasi_id)
          return this.$store.dispatch('atribut/form', this.atribut)
        })
        .then((res) => {
          this.$info('Simpan Data Berhasil')
          this.$refs.dlg.resolve()
          this.$router.push({ name: 'atribut' })
          return res
        })
        .catch((e) => e)
    },
    reset() {
      this.$set(this.atribut, 'default_value', null)
      this.arrayAtribut = []
      this.jumlahAtribut = 1
    },
  },
}
</script>
